module.exports = __webpack_public_path__ + "img/1.42be7d06.png";